import React, { useEffect, useState } from 'react'
import { Grid, InputLabel, Box, Typography, Accordion, AccordionSummary, AccordionDetails, InputAdornment, Tooltip, Checkbox, Modal, FormControl, Select, MenuItem, ListItemText, IconButton } from '@mui/material';
import Layout from './Layout';
import TextField from '../../components/TextField';
import { CaretDown, Info } from '@phosphor-icons/react';
import Button from '../../components/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import { question as questionConstant } from './constants';
import { Close } from '@mui/icons-material';
import { MediaPreview } from './MediaPreview';
import { generateNextLabel, reorderLabels, sortOptions } from './lib';

const LayoutMtf = ({ MTFLHS, setMTFLHS, MTFRHS, setMTFRHS, values, setValues }) => {

    const [RHSOptions, setRHSOptions] = useState();
    const [LHSOptions, setLHSOptions] = useState();

    const [answerMark, setAnswerMark] = useState(false);
    const handleOpen = () => setAnswerMark(true);
    const handleClose = () => setAnswerMark(false);

    const [matchType, setMatchType] = useState();
    const [mediaPreview, setMediaPreview] = useState(false);
    const [currentContentUrl, setCurrentContentUrl] = useState(null);
    const [currentContentType, setCurrentContentType] = useState(null);

    const [lhsLabelType, setLhsLabelType] = useState(""); // 'number' or 'alphabet'
    const [lhslastLabel, setLhsLastLabel] = useState(0); // Last used label for numbers or 'A'
    const [selectedLhsStyle, setSelectedLhsStyle] = useState(null);
    const [selectedLhsTemplate, setSelectedLhsTemplate] = useState(null);

    const [rhsLabelType, setRhsLabelType] = useState(""); // 'number' or 'alphabet'
    const [rhslastLabel, setRhsLastLabel] = useState(0); // Last used label for numbers or 'A'
    const [selectedRhsStyle, setSelectedRhsStyle] = useState(null);
    const [selectedRhsTemplate, setSelectedRhsTemplate] = useState(null);


    useEffect(() => {
        if (MTFLHS && MTFLHS?.length) {
            const lhsStyle = MTFLHS?.[0]?.value?.style;
            const lhsTemplate = MTFLHS?.[0]?.value?.displayTemplate;
            setSelectedLhsStyle(lhsStyle)
            setSelectedLhsTemplate(lhsTemplate)
        }
        if (MTFRHS && MTFRHS?.length) {
            const rhsStyle = MTFRHS?.[0]?.value?.style;
            const rhsTemplate = MTFRHS?.[0]?.value?.displayTemplate;
            setSelectedRhsStyle(rhsStyle);
            setSelectedRhsTemplate(rhsTemplate)
        }
    }, [MTFLHS, MTFRHS])

    useEffect(() => {
        if (selectedLhsStyle && selectedLhsTemplate) {
            setLHSOptions(prevQuestion => ({
                ...prevQuestion,
                style: selectedLhsStyle,
                displayTemplate: selectedLhsTemplate
            }));
        }
        if (selectedRhsStyle && selectedRhsTemplate) {
            setRHSOptions(prevQuestion => ({
                ...prevQuestion,
                style: selectedRhsStyle,
                displayTemplate: selectedRhsTemplate
            }));
        }

    }, [selectedLhsStyle, selectedLhsTemplate, selectedRhsStyle, selectedRhsTemplate])

    const handleDeleteOption = (index, Mtf, setMtf, labelType, setLastLabel) => {
        const newValues = Mtf.filter((_, i) => i !== index);
        setLastLabel(newValues.length ? newValues[newValues.length - 1].label : ""); // Update last label
        const reorderedValues = reorderLabels(newValues, labelType); // Reassign labels
        setMtf(reorderedValues);
    }

    const handleLabelTypeChange = (e, values, setLabelType, setLastLabel) => {
        const type = e.target.value;

        if (values.length > 0) {
            alert("Cannot switch label type while options exist. Clear options first.");
            return;
        }

        setLabelType(type);
        setLastLabel("");
    };

    const handleOption = (e, setOptions, mtf = []) => {
        const { name, value } = e.target
        if (mtf.some(option => option.label === value)) {
            toast.warn('Label already exists. Please choose a different label.')
            return;
        }
        if (value.match(/^[A-Za-z1-9]?$/)) {
            setOptions(prevOpt => ({
                ...prevOpt,
                [name]: value,
            }));
        }
    }

    const handleRhsOption = (RHSOptions) => {
        const nextLabel = generateNextLabel(rhsLabelType, rhslastLabel);
        let temp = {
            label: nextLabel,
            value: {
                style: RHSOptions?.style,
                displayTemplate: RHSOptions?.displayTemplate,
                text: RHSOptions?.text,
                contentURL: RHSOptions?.contentURL || ''
            }
        }
        let arr = [...MTFRHS]
        arr.push(temp)
        setMTFRHS(sortOptions(arr))
        setRHSOptions({ style: selectedRhsStyle, displayTemplate: selectedRhsTemplate, text: '', contentURL: '' })
        setRhsLastLabel(nextLabel)
    }

    const handleLhsOption = (LHSOptions) => {
        const nextLabel = generateNextLabel(lhsLabelType, lhslastLabel);
        let temp = {
            label: nextLabel,
            value: {
                style: LHSOptions?.style,
                displayTemplate: LHSOptions?.displayTemplate,
                text: LHSOptions?.text,
                contentURL: LHSOptions?.contentURL || ''
            },
            answerLabels: [LHSOptions?.answerlabels]
        }
        let arr = [...MTFLHS]
        arr.push(temp)
        setMTFLHS(sortOptions(arr))
        setLHSOptions({ style: selectedLhsStyle, displayTemplate: selectedLhsTemplate, text: '', contentURL: '' })
        setLhsLastLabel(nextLabel);

    }

    const handleAnswerLabel = (e, lhsIndex) => {
        const selectedLabel = e.target.value;

        setMTFLHS((prev) => {
            return prev.map((lhsItem, index) => {
                if (index === lhsIndex) {
                    return {
                        ...lhsItem,
                        answerLabels: selectedLabel ? [selectedLabel] : [],
                    };
                }
                return lhsItem;
            });
        });
    }

    const handleMultipleAnswerLabels = (newValue, lhsIndex) => {
        setMTFLHS((prev) =>
            prev.map((lhs, index) => {
                if (index === lhsIndex) {
                    return { ...lhs, answerLabels: newValue };
                }
                return lhs;
            })
        );
    };

    const handleMatchTypeChange = (e) => {
        const selectedMatchType = e.target.value;
        setMatchType(selectedMatchType);
        setValues((prevState) => {
            if (!prevState || prevState.length === 0) {
                return [
                    {
                        label: selectedMatchType,
                    },
                ];
            } else {
                const updatedValues = [...prevState];
                updatedValues[0] = {
                    ...updatedValues[0],
                    label: selectedMatchType,
                };
                return updatedValues;
            }
        });

        const updatedMTFLHS = MTFLHS.map((lhs) => ({
            ...lhs,
            answerLabels: [],
        }));
        setMTFLHS(updatedMTFLHS);
    };

    const hasMissingAnswers = () => {
        if (matchType === 'One-to-One') {
            return MTFLHS.some((lhs) => !lhs.answerLabels || lhs.answerLabels.length !== 1);
        }

        if (matchType === 'Many-to-One') {
            return MTFLHS.some((lhs) => !lhs.answerLabels || lhs.answerLabels.length === 0);
        }

        if (matchType === 'One-to-Many' || matchType === 'Many-to-Many') {
            const allRHSLabels = MTFRHS.map((rhs) => rhs.label);
            const usedLabels = MTFLHS.flatMap((lhs) => lhs.answerLabels || []);
            return allRHSLabels.some((label) => !usedLabels.includes(label));
        }

        return true;
    };

    const handleMediaPreview = (url, type) => {
        setCurrentContentUrl(url);
        setCurrentContentType(type);
        setMediaPreview(!mediaPreview);
    };

    const handlePreviewClose = () => {
        setCurrentContentUrl(null);
        setCurrentContentType(null);
        setMediaPreview(!mediaPreview)
    }

    useEffect(() => {
        if (!values && !values?.length) {
            setValues((prevState) => {
                if (!prevState || prevState.length === 0) {
                    return [
                        {
                            label: matchType,
                        },
                    ];
                }
            });
        }
        if (values) {
            setMatchType(values[0]?.label)
        }
    }, [values]);

    useEffect(() => {
        const findLabel = (values, setLabelType, setLastLabel, side) => {
            if (values.length > 0) {
                const firstLabel = values[0]?.label;

                if (!isNaN(firstLabel)) {
                    setLabelType("123");
                }
                else if (/^[A-Z]+$/.test(firstLabel)) {
                    setLabelType("AA");
                }
                else if (/^[a-z]+$/.test(firstLabel)) {
                    setLabelType("aa");
                }

                setLastLabel(values[values.length - 1]?.label || "");
            } else {
                if (side === 'lhs') {
                    setLabelType("123");
                    setLastLabel("");
                } else {
                    setLabelType("AA");
                    setLastLabel("");
                }
            }
        }
        if (MTFLHS) {
            findLabel(MTFLHS, setLhsLabelType, setLhsLastLabel, 'lhs')
        }
        if (MTFRHS) {
            findLabel(MTFRHS, setRhsLabelType, setRhsLastLabel, 'rhs')
        }

    }, [MTFLHS, MTFRHS]);

    const extractFilename = (url) => {
        if (!url) return '';

        // Check if URL contains the pattern with UUID and underscore
        const match = url.match(/[a-f0-9-]{36}_(.+)$/);
        if (match) {
            // Extract filename after UUID_ (with extension)
            return match[1];
        }

        // Fallback: get filename from URL (with extension)
        const filename = url.split('/').pop();
        return filename;
    };

    const getDisplayName = (contentUrl, text, mediaType) => {
        if (contentUrl) {
            const filename = extractFilename(contentUrl);
            return `${text && text} (${filename})`;
        }
        return text;
    };

    const isValidOption = (option) => {
        if (!option?.style || !option?.displayTemplate) return false;

        // For text-only style, text is required
        if (option.style === 'text') {
            return !!option.text;
        }

        // For media styles, contentURL is required (text is optional)
        if (option.style === 'text-and-image' ||
            option.style === 'text-and-video' ||
            option.style === 'text-and-audio') {
            return !!option.contentURL;
        }

        return false;
    };

    return (
        <Grid sx={{ mt: 1 }} container style={styles.gridContainer}>
            <Grid item xs={12} md={6} sx={{ padding: 1 }}>
                <Typography
                    align="Left"
                    variant="h6"
                    color="primary.blue"
                    sx={{
                        mb: 2,
                        // margin: '0',
                        fontWeight: '700',
                        lineHeight: '1.5',
                    }}>Match The Following  Left Side <span style={{ color: 'red' }}>*</span></Typography>
                <Grid sx={{ mt: 1 }} container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <InputLabel style={styles.inputLabel}>Style</InputLabel>
                        <FormControl fullWidth>
                            <Select
                                name="style"
                                value={selectedLhsStyle || ''}
                                onChange={(e) => setSelectedLhsStyle(e.target.value)}
                                placeholder="Style"
                                sx={{ height: '47px' }}
                                disabled={MTFLHS?.length > 0}
                            >
                                <MenuItem value=""><em>None</em></MenuItem>
                                {Object.keys(questionConstant.STYLES).map((key, i) => <MenuItem key={i} value={key}>{questionConstant.STYLES[key]}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InputLabel style={styles.inputLabel}>Display Template</InputLabel>
                        <FormControl fullWidth>
                            <Select
                                name="displayTemplate"
                                value={selectedLhsTemplate || ''}
                                onChange={(e) => setSelectedLhsTemplate(e.target.value)}
                                placeholder="Display Template"
                                sx={{ height: '47px' }}
                                disabled={MTFLHS?.length > 0}
                            >
                                <MenuItem value=""><em>None</em></MenuItem>
                                {questionConstant.DISPLAY_TEMPLATE.map((item, index) => {
                                    return <MenuItem key={index} value={item}>{item}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={6} md={12} mt={1}>
                    <InputLabel style={styles.inputLabel} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>Label Type
                        <Tooltip title="The label type must be different from Right side )">
                            <Info />
                        </Tooltip>
                    </InputLabel>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item sx={{ display: 'flex' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Checkbox
                                    checked={lhsLabelType === "AA"}
                                    onChange={(e) => handleLabelTypeChange(e, MTFLHS, setLhsLabelType, setLhsLastLabel)}
                                    value="AA"
                                    disabled={MTFLHS?.length > 0 || rhsLabelType === 'AA'}
                                />
                                <Typography>(ABC)</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Checkbox
                                    checked={lhsLabelType === "aa"}
                                    onChange={(e) => handleLabelTypeChange(e, MTFLHS, setLhsLabelType, setLhsLastLabel)}
                                    value="aa"
                                    disabled={MTFLHS?.length > 0 || rhsLabelType === 'aa'}
                                />
                                <Typography>(abc)</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Checkbox
                                    checked={lhsLabelType === "123"}
                                    onChange={(e) => handleLabelTypeChange(e, MTFLHS, setLhsLabelType, setLhsLastLabel)}
                                    value="123"
                                    disabled={MTFLHS?.length > 0 || rhsLabelType === '123'}
                                />
                                <Typography>(123)</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                {
                    MTFLHS &&
                    <Grid item xs={12}  >
                        {MTFLHS.map((item, index) => {
                            const label = item?.label;
                            const text = item?.value?.text ? item?.value?.text : '';
                            const contentUrl = item?.value?.contentURL ? item?.value?.contentURL : '';
                            const contentType = item.value?.style;
                            const mediaType = questionConstant?.STYLES[contentType] || 'Media';
                            return (
                                <Accordion key={index}>
                                    <AccordionSummary
                                        expandIcon={<CaretDown />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
                                            <Typography
                                                align="left"
                                                color="primary.blue"
                                                sx={{
                                                    margin: '0',
                                                    fontWeight: '700',
                                                    lineHeight: '1.5',
                                                }}>
                                                {`${label})
                                               ${contentUrl ? `${text && text} (${mediaType})` : text}
                                            `}
                                            </Typography>
                                            <Grid >
                                                <DeleteIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} onClick={() => handleDeleteOption(index, MTFLHS, setMTFLHS, lhsLabelType, setLhsLastLabel)} />
                                            </Grid>
                                        </Grid>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Layout
                                            type="show"
                                            mtf={true}
                                            details={item?.value}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </Grid>
                }
                <Grid sx={{ mt: 1 }} container spacing={2} alignItems="center">
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                        <InputLabel style={styles.inputLabel}>Label</InputLabel>
                        <TextField
                            name="label"
                            fullWidth
                            value={generateNextLabel(lhsLabelType, lhslastLabel) || ''}
                            onChange={(e) => handleOption(e, setLHSOptions, MTFLHS)}
                            placeholder="Enter Label"
                            required
                            disabled
                            inputProps={{
                                readOnly: true, // Make it readonly since it's auto-generated
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment sx={{ cursor: "pointer" }} position="end">
                                        <Tooltip title="The label must be either number or alphabet in order (i.e only number or lower or only upper cases)">
                                            <Info />
                                        </Tooltip>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Layout
                        mtf={true}
                        details={LHSOptions}
                        setDetails={setLHSOptions}
                        selectedStyle={selectedLhsStyle}
                        selectedTemplate={selectedLhsTemplate}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box sx={{ mt: 4 }}>
                        <Button size='large' disabled={!isValidOption(LHSOptions)} onClick={() => handleLhsOption(LHSOptions)} variant="contained" color="primary" placeholder={'Add Option'} />
                    </Box>
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} sx={{ padding: 1 }}>
                <Typography
                    align="left"
                    variant="h6"
                    color="primary.blue"
                    sx={{
                        mb: 2,
                        // margin: '0',
                        fontWeight: '700',
                        lineHeight: '1.5',
                    }}>Match The Following  Right Side <span style={{ color: 'red' }}>*</span></Typography>
                <Grid sx={{ mt: 1 }} container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <InputLabel style={styles.inputLabel}>Style</InputLabel>
                        <FormControl fullWidth>
                            <Select
                                name="style"
                                value={selectedRhsStyle || ''}
                                onChange={(e) => setSelectedRhsStyle(e.target.value)}
                                placeholder="Style"
                                sx={{ height: '47px' }}
                                disabled={MTFRHS?.length > 0}
                            >
                                <MenuItem value=""><em>None</em></MenuItem>
                                {Object.keys(questionConstant.STYLES).map((key, i) => <MenuItem key={i} value={key}>{questionConstant.STYLES[key]}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InputLabel style={styles.inputLabel}>Display Template</InputLabel>
                        <FormControl fullWidth>
                            <Select
                                name="displayTemplate"
                                value={selectedRhsTemplate || ''}
                                onChange={(e) => setSelectedRhsTemplate(e.target.value)}
                                placeholder="Display Template"
                                sx={{ height: '47px' }}
                                disabled={MTFRHS?.length > 0}
                            >
                                <MenuItem value=""><em>None</em></MenuItem>
                                {questionConstant.DISPLAY_TEMPLATE.map((item, index) => {
                                    return <MenuItem key={index} value={item}>{item}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6} mt={1}>
                    <InputLabel style={styles.inputLabel} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        Label Type
                        <Tooltip title="The label type must be different from Left side )">
                            <Info />
                        </Tooltip>
                    </InputLabel>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item sx={{ display: 'flex' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Checkbox
                                    checked={rhsLabelType === "AA"}
                                    onChange={(e) => handleLabelTypeChange(e, MTFRHS, setRhsLabelType, setRhsLastLabel)}
                                    value="AA"
                                    disabled={MTFRHS?.length > 0 || lhsLabelType === 'AA'}
                                />
                                <Typography>(ABC)</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Checkbox
                                    checked={rhsLabelType === "aa"}
                                    onChange={(e) => handleLabelTypeChange(e, MTFRHS, setRhsLabelType, setRhsLastLabel)}
                                    value="aa"
                                    disabled={MTFRHS?.length > 0 || lhsLabelType === 'aa'}
                                />
                                <Typography>(abc)</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Checkbox
                                    checked={rhsLabelType === "123"}
                                    onChange={(e) => handleLabelTypeChange(e, MTFRHS, setRhsLabelType, setRhsLastLabel)}
                                    value="123"
                                    disabled={MTFRHS?.length > 0 || lhsLabelType === '123'}
                                />
                                <Typography>(123)</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                {
                    MTFRHS &&
                    <Grid item xs={12}  >
                        {MTFRHS.map((item, index) => {
                            const label = item?.label;
                            const text = item?.value?.text ? item?.value?.text : '';
                            const contentUrl = item?.value?.contentURL ? item?.value?.contentURL : '';
                            const contentType = item.value?.style;
                            const mediaType = questionConstant?.STYLES[contentType] || 'Media';
                            return (
                                <Accordion key={index}>
                                    <AccordionSummary
                                        expandIcon={<CaretDown />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }} >
                                            <Typography
                                                align="left"
                                                color="primary.blue"
                                                sx={{
                                                    margin: '0',
                                                    fontWeight: '700',
                                                    lineHeight: '1.5',
                                                }}>
                                                {`${label})
                                               ${contentUrl ? `${text && text} (${mediaType})` : text}
                                            `}
                                            </Typography>
                                            <Grid >
                                                <DeleteIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} onClick={() => handleDeleteOption(index, MTFRHS, setMTFRHS, rhsLabelType, setRhsLastLabel)} />
                                            </Grid>
                                        </Grid>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Layout
                                            type="show"
                                            mtf={true}
                                            details={item?.value}
                                        />
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </Grid>
                }
                <Grid sx={{ mt: 1 }} container spacing={2} alignItems="center">
                    <Grid item xs={6} sm={6} md={6} lg={6} >
                        <InputLabel style={styles.inputLabel}>Label</InputLabel>
                        <TextField
                            name="label"
                            fullWidth
                            value={generateNextLabel(rhsLabelType, rhslastLabel) || ''}
                            onChange={(e) => handleOption(e, setRHSOptions, MTFRHS)}
                            placeholder="Enter Label"
                            required
                            disabled
                            inputProps={{
                                readOnly: true, // Make it readonly since it's auto-generated
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment sx={{ cursor: "pointer" }} position="end">
                                        <Tooltip title="The label must be either number or alphabet in order (i.e only number or lower or only upper cases)">
                                            <Info />
                                        </Tooltip>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} >
                    <Layout
                        mtf={true}
                        details={RHSOptions}
                        setDetails={setRHSOptions}
                        selectedStyle={selectedRhsStyle}
                        selectedTemplate={selectedRhsTemplate}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{ mt: 4 }}>
                        <Button size='large' disabled={!isValidOption(RHSOptions)} onClick={() => handleRhsOption(RHSOptions)} variant="contained" color="primary" placeholder={'Add Option'} />
                    </Box>
                </Grid>
            </Grid>
            <Grid item xs={12} textAlign={"center"}>
                <Box sx={{ mt: 4 }}>
                    <Button size='large' disabled={!MTFLHS.length || !MTFRHS.length} variant="contained" color="primary" placeholder={'Mark Answers'} onClick={handleOpen} />
                </Box>
            </Grid>

            <Modal
                open={answerMark}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styles.modal}>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            color: 'grey.500',
                            '&:hover': { color: 'grey.700' },
                        }}
                    >
                        <Close />
                    </IconButton>
                    <Typography
                        align="center"
                        variant="h6"
                        color="primary.blue"
                        sx={{
                            mb: 2,
                            // margin: '0',
                            fontWeight: '700',
                            lineHeight: '1.5',
                        }}>Mark Correct Answers</Typography>
                    <Grid sx={{ mt: 1 }} container style={styles.gridContainer} spacing={1}>
                        <Grid item xs={12}>
                            <Grid item xs={4}>
                                <InputLabel style={styles.inputLabel}>Select Match Type</InputLabel>
                                <FormControl fullWidth>
                                    <Select
                                        name="matchType"
                                        value={values && values[0]?.label || ''}
                                        onChange={handleMatchTypeChange}
                                        placeholder="Select Match Type"
                                        sx={{ height: '47px' }}
                                    >
                                        {questionConstant.MATCHRELATIONS.map((item, index) => {
                                            return <MenuItem key={index} value={item}>{item}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                align="center"
                                variant="h6"
                                color="green"
                                sx={{
                                    mb: 1,
                                    fontWeight: '700',
                                    lineHeight: '1.5',
                                }}>Correct Answer</Typography>
                        </Grid>
                        <Grid item xs={4} textAlign="center">
                            {MTFLHS?.map((lhs, index) => {
                                const label = lhs?.label;
                                const text = lhs?.value?.text ? lhs?.value?.text : '';
                                const contentUrl = lhs?.value?.contentURL ? lhs?.value?.contentURL : '';
                                const contentType = lhs?.value?.style;
                                const mediaType = questionConstant?.STYLES[contentType] || 'Media';
                                return <Box
                                    key={index}
                                    sx={{
                                        mt: 1,
                                        background: '#ffc74a40',
                                        borderRadius: 1,
                                        p: 1.5, // Padding for consistent appearance
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        '& .Mui-disabled': {
                                            WebkitTextFillColor: '#000 !important',
                                        },
                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#000',
                                            flexGrow: 1,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {/* {`${label}) ${contentUrl ? `${text && text} (${mediaType})` : text}`} */}
                                        <Tooltip title={`${label}) ${getDisplayName(contentUrl, text, mediaType)}`}>
                                            {`${label}) ${getDisplayName(contentUrl, text, mediaType)}`}
                                        </Tooltip>
                                    </Typography>
                                    {contentUrl && (
                                        <>
                                            <Button
                                                size="small"
                                                onClick={() => handleMediaPreview(contentUrl, contentType)}
                                                placeholder={`view`}
                                                sx={{ padding: 0, fontSize: '12px' }}
                                            />
                                            <MediaPreview
                                                contentURL={currentContentUrl}
                                                contentType={currentContentType}
                                                handleClose={handlePreviewClose}
                                                mediaPreview={mediaPreview}
                                                BackdropProps={{
                                                    style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
                                                }}
                                            />
                                        </>
                                    )}
                                </Box>
                            })}
                        </Grid>
                        <Grid item xs={4} textAlign="center">
                            {MTFLHS?.map((item, index) => (
                                <FormControl key={index} fullWidth sx={{ mt: 1 }}>
                                    {matchType === 'One-to-Many' || matchType === 'Many-to-Many' ? (
                                        <Select
                                            multiple
                                            value={item.answerLabels || []}
                                            onChange={(e) => handleMultipleAnswerLabels(e.target.value, index)}
                                            renderValue={(selected) => selected.join(', ')}
                                            sx={{ height: '46px' }}
                                            disabled={!matchType}
                                        ><MenuItem><em>None</em></MenuItem>
                                            {MTFRHS?.map((ans, ansIndex) => {
                                                const isDisabled =
                                                    matchType === 'One-to-Many' &&
                                                    MTFLHS.some((lhs, lhsIndex) => lhsIndex !== index && lhs.answerLabels?.includes(ans.label));

                                                const isCurrentLHSSelected = item.answerLabels?.includes(ans.label);
                                                const disabledForOthers = isDisabled && !isCurrentLHSSelected;
                                                return (
                                                    <MenuItem
                                                        key={ans?.label}
                                                        value={ans?.label}
                                                        disabled={disabledForOthers}
                                                    >
                                                        <Checkbox checked={item.answerLabels?.includes(ans.label)} />
                                                        <ListItemText primary={ans.label} />
                                                    </MenuItem>
                                                )
                                            })}
                                        </Select>
                                    ) : (
                                        <Select
                                            name="correctAnswer"
                                            value={item?.answerLabels[0] || ''}
                                            onChange={(e) => handleAnswerLabel(e, index)}
                                            placeholder="Correct Answer"
                                            sx={{ height: '46px' }}
                                            disabled={!matchType}
                                        >
                                            <MenuItem><em>None</em></MenuItem>
                                            {MTFRHS?.map((ans, index) => {
                                                const isDisabled =
                                                    matchType === 'One-to-One' &&
                                                    MTFLHS.some((lhs, idx) => lhs.answerLabels?.includes(ans.label));
                                                return (
                                                    <MenuItem
                                                        key={ans?.label}
                                                        value={ans?.label}
                                                        disabled={isDisabled}>
                                                        <em>{ans?.label}</em>
                                                    </MenuItem>
                                                )
                                            })}
                                        </Select>
                                    )}
                                </FormControl>
                            ))}
                        </Grid>
                        <Grid item xs={4} textAlign="center">
                            {MTFRHS?.map((rhs, index) => {
                                const label = rhs?.label;
                                const text = rhs?.value?.text ? rhs?.value?.text : '';
                                const contentUrl = rhs?.value?.contentURL ? rhs?.value?.contentURL : '';
                                const contentType = rhs?.value?.style;
                                const mediaType = questionConstant?.STYLES[contentType] || 'Media';
                                return <Box
                                    key={index}
                                    sx={{
                                        mt: 1,
                                        background: '#cde6f5',
                                        borderRadius: 1,
                                        p: 1.5,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        '& .Mui-disabled': {
                                            WebkitTextFillColor: '#000 !important',
                                        },
                                        border: '1px solid rgba(0, 0, 0, 0.23)',
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#000',
                                            flexGrow: 1,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {/* {`${label}) ${contentUrl ? `${text && text} (${mediaType})` : text}`} */}
                                        <Tooltip title={`${label}) ${getDisplayName(contentUrl, text, mediaType)}`}>
                                            {`${label}) ${getDisplayName(contentUrl, text, mediaType)}`}
                                        </Tooltip>
                                    </Typography>

                                    {contentUrl && (
                                        <>
                                            <Button
                                                size="small"
                                                onClick={() => handleMediaPreview(contentUrl, contentType)}
                                                placeholder={`view`}
                                                sx={{ padding: 0, fontSize: '12px' }}
                                            />
                                            <MediaPreview
                                                contentURL={currentContentUrl}
                                                contentType={currentContentType}
                                                handleClose={handlePreviewClose}
                                                mediaPreview={mediaPreview}
                                                BackdropProps={{
                                                    style: { backgroundColor: 'rgba(0, 0, 0, 0.2)' }
                                                }}
                                            />
                                        </>
                                    )}
                                </Box>
                            })}
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ mt: 4, textAlign: 'right' }}>
                                <Button size='large' variant="contained" color="primary" placeholder={'Save Answers'} disabled={hasMissingAnswers()} onClick={handleClose} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </Grid>
    )
}

const styles = {
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    gridContainer: {
        mt: 2,
    },
    suggestionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px',
    },
    suggestionItem: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '2px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
        backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
    },
    uploadBtn: {
        width: '50px',
        height: '50px',
        borderRadius: '5px',
    },
    hiddenInput: {
        display: 'none',
    },
    actionBtnItem: {
        marginLeft: '5px',
        marginRight: '5px',
        cursor: 'pointer'
    },
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        p: 4,
        borderRadius: 1
    }
};
export default LayoutMtf